// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leOV4a8LgtgD4NYr4haR {
  position: relative;
  text-align: center
}
.nTEStWJMTPp0E2d18fvt {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  cursor: pointer;
  border-color: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  background: transparent
}
.YFofkxLrPO6ii7nwr38g {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem
}
.bcC2hgeSKd4Dk8aG27Yl {
  font-family: Noto Sans;
  font-size: 20px;
  font-weight: 700
}
.OgxklYZ9peYbR_QZXTJF {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}
.TnXaS9kNww10T3tojwVA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.xfwLKPenKgNKxkfAPWnL {
  margin: auto;
  margin-bottom: 2.25rem;
  display: flex;
  height: 45px;
  width: 250px !important;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.xfwLKPenKgNKxkfAPWnL:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
.mFuFIufl8vuP3z6lsZLM {
  margin-bottom: 15px;
  height: 44px;
  width: 250px;
  border-radius: 5px !important;
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
  text-align: center
}

.mFuFIufl8vuP3z6lsZLM:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/components/Pledge/DownloanModal/DownloanModal.module.css"],"names":[],"mappings":"AACE;EAAA,kBAA2B;EAA3B;AAA2B;AAG3B;EAAA,kBAAkE;EAAlE,cAAkE;EAAlE,YAAkE;EAAlE,eAAkE;EAAlE,kBAAkE;EAAlE,kBAAkE;EAAlE,oBAAkE;EAClE;AADkE;AAIlE;EAAA,kBAAsC;EAAtC,qBAAsC;EAAtC,aAAsC;EAAtC,uBAAsC;EAAtC;AAAsC;AAGtC;EAAA,sBAAuC;EAAvC,eAAuC;EAAvC;AAAuC;AAGvC;EAAA,gBAAsD;EAAtD,aAAsD;EAAtD,sBAAsD;EAAtD,mBAAsD;EAAtD;AAAsD;AAGtD;EAAA,aAAkG;EAAlG,sBAAkG;EAAlG,mBAAkG;EAAlG,uBAAkG;EAAlG,iBAAkG;EAAlG,oBAAkG;EAAlG,sBAAkG;EAAlG,eAAkG;EAAlG,gBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;AAGlG;EAAA,YAAkF;EAAlF,sBAAkF;EAAlF,aAAkF;EAAlF,YAAkF;EAAlF,uBAAkF;EAAlF,uBAAkF;EAAlF,kBAAkF;EAAlF,0DAAkF;EAAlF,oBAAkF;EAAlF;AAAkF;AAGlF;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;AAGhC;EAAA,mBAA+E;EAA/E,YAA+E;EAA/E,YAA+E;EAA/E,6BAA+E;EAA/E,kBAA+E;EAA/E,4DAA+E;EAA/E;AAA+E;;AAI/E;EAAA,kBAAuB;EAAvB;AAAuB","sourcesContent":[".otpModal {\n  @apply relative text-center;\n}\n.closeBtn {\n  @apply absolute text-xl cursor-pointer border-[none] right-3 top-3;\n  background: transparent;\n}\n.otpWrapper {\n  @apply flex justify-center gap-4 my-10;\n}\n.header {\n  @apply text-[20px] font-bold font-inter;\n}\n.modalContainer {\n  @apply flex flex-col justify-center items-center  mt-8;\n}\n.infoContainer {\n  @apply flex flex-col justify-center items-center text-gray-400 font-body text-body font-inter py-4;\n}\n.applyButton {\n  @apply flex bg-secondary text-white !w-[250px] h-[45px] justify-center m-auto mb-9;\n}\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n.customInput {\n  @apply bg-amountInputBG w-[250px] h-[44px] !rounded-[5px] mb-[15px] text-center;\n}\n\n.customInput:hover {\n  @apply bg-amountInputBG;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpModal": `leOV4a8LgtgD4NYr4haR`,
	"closeBtn": `nTEStWJMTPp0E2d18fvt`,
	"otpWrapper": `YFofkxLrPO6ii7nwr38g`,
	"header": `bcC2hgeSKd4Dk8aG27Yl`,
	"modalContainer": `OgxklYZ9peYbR_QZXTJF`,
	"infoContainer": `TnXaS9kNww10T3tojwVA`,
	"applyButton": `xfwLKPenKgNKxkfAPWnL`,
	"customInput": `mFuFIufl8vuP3z6lsZLM`
};
export default ___CSS_LOADER_EXPORT___;
